module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_datarepup.4ea325537817adb813374200af66d1fc.png";